import { useEffect, useState } from "react";

export type LayoutMode = 'light' | 'dark';

const read = (): LayoutMode =>
    document.documentElement.getAttribute('data-layout-mode') === 'dark' ? 'dark' : 'light';

/**
 * The theme the user picked, as the layout saga applies it: `data-layout-mode` on <html>.
 * For components that draw their own colours and need telling (React Flow's colorMode,
 * react-data-table-component's theme). Read from the DOM rather than the store so it follows a
 * theme switch without depending on Redux, and works where no store is rendered (tests).
 */
export function useLayoutMode(): LayoutMode {
    const [mode, setMode] = useState<LayoutMode>(read);

    useEffect(() => {
        const observer = new MutationObserver(() => setMode(read()));
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-layout-mode'] });
        setMode(read());

        return () => observer.disconnect();
    }, []);

    return mode;
}
